import React, { useState, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { QRCodeCanvas } from 'qrcode.react';
import '../styles/Header.css';
import NewsTicker from './NewsTicker'; // 👈 ADD THIS

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [shareOpen, setShareOpen] = useState(false);
  const [showQR, setShowQR] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();
  const qrRef = useRef(null);

  const toggleMenu = () => setMenuOpen(!menuOpen);
  const goTo = (path) => {
    navigate(path);
    setMenuOpen(false);
    setShareOpen(false);
  };
  const isActive = (path) => location.pathname === path;

  const shareLinkToWhatsApp = () => {
    const url = `https://api.whatsapp.com/send?text=${encodeURIComponent(window.location.href)}`;
    window.open(url, '_blank');
    setShareOpen(false);
  };

  const getCanvasDataURL = () => {
    const wrapper = qrRef.current;
    if (!wrapper) return null;
    const canvas = wrapper.querySelector('canvas');
    if (!canvas) return null;
    return canvas.toDataURL('image/png');
  };

  const isMobile = () =>
    /Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

  const shareQRToWhatsApp = async () => {
    const dataUrl = getCanvasDataURL();
    if (!dataUrl) return alert('QR not ready yet');

    try {
      const blob = await (await fetch(dataUrl)).blob();
      const file = new File([blob], 'qr-code.png', { type: 'image/png' });

      if (isMobile()) {
        if (navigator.canShare && navigator.canShare({ files: [file] })) {
          await navigator.share({
            files: [file],
            text: 'Here is the QR code for this page.',
            title: 'QR Code',
          });
          setShowQR(false);
        } else {
          const waURL = `https://api.whatsapp.com/send?text=${encodeURIComponent(window.location.href)}`;
          window.open(waURL, '_blank');
          setShowQR(false);
        }
      } else {
        const blobUrl = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = blobUrl;
        link.download = 'qr-code.png';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        setTimeout(() => URL.revokeObjectURL(blobUrl), 100);

        alert(
          'QR code downloaded!\n\n' +
          'To share via WhatsApp Web:\n' +
          '1. Open https://web.whatsapp.com\n' +
          '2. Open a chat\n' +
          '3. Click the attachment icon\n' +
          '4. Select "Photos & Videos" or "Document"\n' +
          '5. Choose the downloaded qr-code.png\n' +
          '6. Send it!'
        );
        setShowQR(false);
      }
    } catch (err) {
      console.error('Error sharing QR', err);
      alert('Sharing failed. Please copy the page link manually.');
      setShowQR(false);
    }
  };

  const copyLink = async () => {
    try {
      await navigator.clipboard.writeText(window.location.href);
      alert('Website link copied!');
      setShareOpen(false);
    } catch {
      alert('Failed to copy link. Please copy manually.');
    }
  };

  return (
    <>
      <header className="header" style={{ color: "black" }}>
        <div className="container">
          <div className="logo" onClick={() => goTo("/")}>
            <img src="taxtimelogo.png" alt="Tax Timez" className="logo-img" />
          </div>

          <div className="hamburger" onClick={toggleMenu}>
            {menuOpen ? <span className="close-icon">&#10005;</span> : <span className="hamburger-icon">&#9776;</span>}
          </div>

          <nav className={`nav ${menuOpen ? "open" : ""}`}>
            <ul className="nav-list">
              <li className={isActive("/")} onClick={() => goTo("/")}>
                <button className={`menu-btn ${isActive("/") ? "active" : ""}`}>Home</button>
              </li>
              <li className={isActive("/about")} onClick={() => goTo("/about")}>
                <button className={`menu-btn ${isActive("/about") ? "active" : ""}`}>About</button>
              </li>
              <li className={isActive("/services")} onClick={() => goTo("/services")}>
                <button className={`menu-btn ${isActive("/services") ? "active" : ""}`}>Services</button>
              </li>
              <li className={isActive("/contact")} onClick={() => goTo("/contact")}>
                <button className={`menu-btn ${isActive("/contact") ? "active" : ""}`}>Contact</button>
              </li>
              <li className={isActive("/blogs")} onClick={() => goTo("/blogs")}>
                <button className={`menu-btn ${isActive("/blogs") ? "active" : ""}`}>Blogs</button>
              </li>

              <li>
                <div className="relative">
                  <button className="menu-btn" onClick={() => setShareOpen(prev => !prev)}>Share</button>
                  {shareOpen && (
                    <div className="share-dropdown">
                      <button onClick={() => { setShowQR(true); setShareOpen(false); }}>Share URL as QR Code</button>
                      <button onClick={copyLink}>Copy Link</button>
                    </div>
                  )}
                </div>
              </li>

              <li className="menu-btn">
                <a
                  href="https://practicemanagementplatform.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ color: "black", textDecoration: "none" }}
                >
                  Login
                </a>
              </li>
            </ul>
          </nav>
        </div>
      </header>

      {/* 🔔 NEWS TICKER BELOW HEADER */}
      <NewsTicker />

      {showQR && (
        <div className="qr-overlay" onClick={() => setShowQR(false)}>
          <div className="qr-box" onClick={(e) => e.stopPropagation()}>
            <h3>Scan to Share</h3>
            <div ref={qrRef} style={{ marginTop: "20px" }}>
              <QRCodeCanvas value={window.location.href} size={180} />
            </div>

            <div style={{ marginTop: 12 }}>
              <button className="qr-close" onClick={() => setShowQR(false)}>Close</button>
              <button onClick={shareQRToWhatsApp} style={{ marginLeft: 8 }}>Share QR via WhatsApp</button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Header;
